import React, { useRef, useImperativeHandle, forwardRef } from 'react';

import { DataChange } from 'devextreme/common/grids';

import FieldGrid, { FieldGridHandle } from './FieldGrid';

import SynchroFieldMappingDto from '../../classes/dtos/pathsynchromodule/SynchroFieldMappingDto';

import TransformationCapabilitiesDto from '../../classes/dtos/transformationmodule/TransformationCapabilitiesDto';
import FieldReferenceIdAndKeyDto from '../../classes/dtos/FieldReferenceIdAndKeyDto';
import PathSynchroMappingCapabilitiesDto from '../../classes/dtos/pathsynchromodule/PathSynchroMappingCapabilitiesDto';


interface SynchroMappingFieldsProps {
    // Path being edited: required by the AI transformation generation (rights check and generation log).
    PathId: number;
    MappingChanges: DataChange[] | undefined;

    SourceFields: FieldReferenceIdAndKeyDto[];
    TargetFields: FieldReferenceIdAndKeyDto[];
    Capabilities: PathSynchroMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[];
    Mapping: SynchroFieldMappingDto[];
    IsSimpleFilterMode: boolean;
    FiltersEnabled: boolean;
    TableReferenceSourceId: number | null;
    PathSourceId: number | null;
    TableReferenceTargetId: number;

    AdvancedFilterMode: boolean;
    SetAdvancedFilterMode(value: boolean): void;
    AdvancedFilterModeLocked: boolean;

    SetMappingChanges(changes: DataChange[], origin: SynchroFieldMappingDto[]): void;
}

export interface SynchroMappingFieldsHandle {
    Save: () => void;
}

const SynchroMappingFields = forwardRef<SynchroMappingFieldsHandle, SynchroMappingFieldsProps>(({ PathId, MappingChanges, SetMappingChanges, SourceFields, TargetFields, Capabilities, TransformationsCapabilities, Mapping, IsSimpleFilterMode, FiltersEnabled, TableReferenceSourceId, PathSourceId, TableReferenceTargetId, AdvancedFilterMode, SetAdvancedFilterMode, AdvancedFilterModeLocked }, ref) => {

    useImperativeHandle(ref, () => ({
        Save() {
            if (fieldGridRef.current) {
                fieldGridRef.current.Save();
            }
        }
    }));

    const fieldGridRef = useRef<FieldGridHandle>(null);

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
            <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
                <FieldGrid
                    ref={fieldGridRef}
                    PathId={PathId}
                    MappingChanges={MappingChanges}
                    SetMappingChanges={SetMappingChanges}

                    SourceFields={SourceFields}
                    TargetFields={TargetFields}
                    Capabilities={Capabilities}
                    TransformationsCapabilities={TransformationsCapabilities}
                    Mapping={Mapping}
                    IsSimpleFilterMode={IsSimpleFilterMode}
                    FiltersEnabled={FiltersEnabled}
                    TableReferenceSourceId={TableReferenceSourceId}
                    PathSourceId={PathSourceId}
                    TableReferenceTargetId={TableReferenceTargetId}
                    AdvancedFilterMode={AdvancedFilterMode}
                    SetAdvancedFilterMode={SetAdvancedFilterMode}
                    AdvancedFilterModeLocked={AdvancedFilterModeLocked}
                />
            </div>
        </div>
    );
});

export default SynchroMappingFields;